module.exports = __webpack_public_path__ + "static/media/Block by Block_20191010_135253260605546.28b618fc.jpg";